import distributionService from "../../services/DistributionService";
import i18n from "../../i18n/index";

export default {
  data() {
    return {
      menu: false,
      searchDate: new Date().toISOString().substr(0, 10),
      headers: [
        {
          text: i18n.t('headers.shipping-date'),
          sortable: false,
          value: "deliveryDate"
        },
        {
          text: i18n.t('headers.total-orders'),
          sortable: false,
          value: "totalCount"
        },
        {
          text: i18n.t('headers.orders-pendings'),
          sortable: false,
          value: "checkedOutCount"
        },
        {
          text: i18n.t('headers.responsable'),
          sortable: false,
          value: "userName"
        }
      ],
      itemsData: []
    };
  },
  props: {
    onRowClick: {
      type: Function,
      default: () => {}
    }
  },
  watch: {},
  created() {
    this.searchPending();
  },
  methods: {
    searchPending() {
      this.menu = false;
      distributionService.getPendingByDate(this.searchDate).then(response => {
        this.itemsData = response.data;
      });
    }
  }
};
